export default "__VITE_ASSET__ObtC1QQb__"